module.exports = __webpack_public_path__ + "img/wine_fair.4b1c0a05.jpg";